import { Unit, GatherResourceTaskList } from "../../types/unit";
import { AStar } from "../../modes/Game/utils/movement";
import { Grid } from "../../types/grid";
import { RESOURCE_TYPES } from "../../types/resource";
import { Building } from "../../types/building";
import { GetResourceType } from "../../modes/Game/utils/resource";


export function processUnits(grid: Grid, units: Unit[], buildings: Building[], defaultUserState: { ore: number, timber: number }, frame: number) {

    units.forEach(unit => {
        //UpdateTask(unit);

        let oreRepo = buildings.find(obj => {
            return obj.resourceAccepted === RESOURCE_TYPES.ORE;
        })

        let timberRepo = buildings.find(obj => {
            return obj.resourceAccepted === RESOURCE_TYPES.TIMBER;
        })

        let currentTask = unit.taskStack[unit.taskStack.length - 1];

        switch (currentTask) {

            case "MOVE":

                if (unit.path.coords.length === 0) {

                    let path = AStar(grid, unit.position, unit.destination);

                    if (path.coords.length > 0) {
                        unit.path = path;
                    }
                }

                if (unit.currentTick === unit.ticksToMove) {

                    if (unit.path.currentPosition === unit.path.coords.length - 1) {
                        unit.path.moveDirection = -1;
                    }
                    else if (unit.path.currentPosition === 0) {
                        unit.path.moveDirection = 1;
                    }

                    if (unit.path.coords.length > 0) {
                        unit.position.y = unit.path.coords[unit.path.currentPosition += unit.path.moveDirection].y;
                        unit.position.x = unit.path.coords[unit.path.currentPosition].x;
                    }

                    unit.currentTick = 0;
                }
                else {
                    unit.currentTick++;
                }

                if (unit.position.y === unit.destination.y &&
                    unit.position.x === unit.destination.x) {

                    unit.taskStack.pop();

                    if (unit.taskStack[unit.taskStack.length - 1] !== "GATHER_RESOURCE" &&
                        unit.taskStack[unit.taskStack.length - 1] !== "DEPOSIT_RESOURCE") {
                        unit.path = {
                            coords: [],
                            moveDirection: 0,
                            currentPosition: 0,
                        };
                    }
                }

                break;

            case "GATHER_RESOURCE":

                if (unit.position.y === unit.destination.y &&
                    unit.position.x === unit.destination.x) {

                    let currentCellResourceType = GetResourceType(grid[unit.position.y][unit.position.x]);

                    if (currentCellResourceType > 0) {

                        if (unit.currentTick === unit.ticksToGather) {
                            /* TODO(Rey): Set resource count to a value that we have defined for this resource type. 
                                          This may also depend on the type of unit that is gathering it, their level, 
                                          or some other factor. We could even add an option where the unit will take 
                                          longer to gather the resource but get more of it. This could be a player 
                                          setting that can be toggled. */
                            unit.resource.ResourceCount = 5;
                            unit.currentTick = 0;
                        }
                        else if (unit.resource.ResourceCount === 0) {
                            unit.currentTick++;
                        }

                        if (!unit.repoPathTraced) {
                            unit.path = {
                                coords: [],
                                moveDirection: 0,
                                currentPosition: 0,
                            };
                        }

                        // TODO(Rey): Clean up this mess of repetitive logic
                        if (unit.resource.ResourceType === RESOURCE_TYPES.ORE &&
                            currentCellResourceType === RESOURCE_TYPES.ORE &&
                            unit.resource.ResourceCount > 0 &&
                            //!unit.repoPathTraced &&
                            oreRepo) {

                            unit.destination.y = oreRepo.position.y + 1;
                            unit.destination.x = oreRepo.position.x;

                            // TODO(Rey): Handle setting this in the movement code
                            unit.repoPathTraced = true;

                            unit.taskStack.pop();
                        }
                        else if (unit.resource.ResourceType === RESOURCE_TYPES.TIMBER &&
                            currentCellResourceType === RESOURCE_TYPES.TIMBER &&
                            unit.resource.ResourceCount > 0 &&
                            //!unit.repoPathTraced &&
                            timberRepo) {

                            unit.destination.y = timberRepo.position.y + 1;
                            unit.destination.x = timberRepo.position.x;

                            // TODO(Rey): Handle setting this in the movement code
                            unit.repoPathTraced = true;

                            unit.taskStack.pop();
                        }
                        else {
                            if (unit.resource.ResourceCount > 0 &&
                                (!oreRepo || !timberRepo) &&
                                frame === 1) {
                                console.log("You have not built a repository that accepts the resource selected. Build one and your unit will continue to gather resources. (UnitID: " + unit.id + ", X: " + unit.position.x + ", Y: " + unit.position.y + ")");
                            }

                            if (unit.resource.ResourceCount > 0 &&
                                unit.resource.ResourceType !== currentCellResourceType &&
                                frame === 1) {
                                console.log("Unit's selected resource to gather does not match the resource of the cell on which they are standing.");
                            }
                        }
                    }
                    else if (frame === 1) {
                        console.log("There is no resource at this location that matches the defined types.");

                        unit.taskStack = [];

                        unit.destination.y = -1;
                        unit.destination.x = -1;

                        unit.path = {
                            coords: [],
                            moveDirection: 0,
                            currentPosition: 0,
                        };
                    }
                }
                else if (frame === 1) {
                    console.log("Unit is not at the resource destination cell.");
                }

                break;

            case "DEPOSIT_RESOURCE":

                if (unit.resource.ResourceType === RESOURCE_TYPES.ORE) {
                    defaultUserState.ore += unit.resource.ResourceCount;
                    unit.resource.ResourceCount = 0;
                }
                else if (unit.resource.ResourceType === RESOURCE_TYPES.TIMBER) {
                    defaultUserState.timber += unit.resource.ResourceCount;
                    unit.resource.ResourceCount = 0;
                }

                unit.taskStack.pop();

                unit.taskStack = unit.taskStack.concat(GatherResourceTaskList);

                unit.destination.y = unit.path.coords[unit.path.coords.length - 1].y;
                unit.destination.x = unit.path.coords[unit.path.coords.length - 1].x;

                // TODO(Rey): Implement this when we can define the total number of resources in a cell in the editor
                // if(currentResourceIsDepleted) {

                // unit.repoPathTraced = false; 

                //     unit.path = {
                //         coords: [],
                //         moveDirection: 0,
                //         currentPosition: 0,
                //     };
                // }

                break;

            case "FIGHT":

                // TODO(Rey): Implement groundbreaking combat system

                break;

            default:
        }
    });

    return { units: units, userState: defaultUserState };
}
